<template>
  <div class="teaching-schedule-work-upload-preview"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="previewInfo">
      <div v-if="previewInfo.student"
           class="header">
        <div class="title theme-text">{{previewInfo.student.trueName}}（{{previewInfo.student.regNo}}）</div>
      </div>
      <div class="body">
        <el-form size="mini"
                 label-width="72px"
                 label-suffix="：">
          <el-form-item v-if="previewInfo.content"
                        label="提交内容">
            <span>{{previewInfo.content}}</span>
          </el-form-item>
          <el-form-item v-if="previewInfo.files && previewInfo.files.length"
                        label="提交附件">
            <div class="files">
              <div v-for="(file, index) in previewInfo.files"
                   :key="'file-' + index"
                   class="file-item">
                <a :href="$contextPath(file.url)"
                   target="_blank"
                   class="file-link">
                  <i class="el-icon-document"></i>
                  <span class="file-name">作业文件{{ index + 1 }}</span>
                </a>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>作业预览数据加载失败</div>
        <el-button type="text"
                   @click="loadPreviewInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'TeachingScheduleWorkUploadPreview',
  components: {
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    extraParams: Object
  },
  data () {
    return {
      loading: false,
      previewInfo: null
    }
  },
  computed: {},
  methods: {
    loadPreviewInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/work/submit/preview',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.rowData.id
        }, this.extraParams))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.previewInfo = response.data['previewInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadPreviewInfo()
  }
}
</script>

<style lang="scss">
  .teaching-schedule-work-upload-preview {
    max-width: 100%;
    width: 320px;
    min-height: 120px;
    & > .header {
      margin-bottom: 10px;
      border-bottom: 1px solid #ebeef5;
      padding-bottom: 10px;
      & > .title {
        font-size: 12px;
      }
    }
    & > .body {
      .el-form {
        .el-form-item {
          margin-bottom: 5px;
          &:last-child {
            margin-bottom: 0;
          }
          .el-form-item__label {
            font-size: 12px;
          }
          .el-form-item__content {
            font-size: 12px;
            .files {
              .file-item {
                margin-bottom: 8px;
                &:last-child {
                  margin-bottom: 0;
                }
                .file-link {
                  display: flex;
                  align-items: center;
                  padding: 8px;
                  border: 1px solid #d9d9d9;
                  border-radius: 4px;
                  background-color: #fafafa;
                  text-decoration: none;
                  color: #333;
                  transition: all 0.3s;
                  &:hover {
                    background-color: #f0f9ff;
                    border-color: #409EFF;
                    color: #409EFF;
                  }
                  .el-icon-document {
                    margin-right: 8px;
                    color: #409EFF;
                    font-size: 16px;
                  }
                  .file-name {
                    font-size: 12px;
                    flex: 1;
                    word-break: break-all;
                  }
                }
              }
            }
          }
        }
      }
    }
    .layout-hint {
      height: 120px;
    }
  }
</style>
